// extracted by mini-css-extract-plugin
export var defaultWrapper = "_kf-3";
export var downloadButton = "_kf-4";
export var fileContainer = "_kf-9 _kf-7";
export var fileContainerBase = "_kf-7";
export var fileContainerBaseSm = "_kf-a _kf-7";
export var fileContainerFixedHeight = "_kf-8 _kf-7";
export var fileContainerFixedHeightSm = "_kf-c _kf-a _kf-7";
export var fileContainerSm = "_kf-b _kf-a _kf-7";
export var fileInfo = "_kf-5";
export var fileInfoWidthRestricted = "_kf-6";
export var fileType = "_kf-1";
export var fileTypeName = "_kf-2";
export var fileTypeSm = "_kf-d _kf-1";
export var image = "_kf-0";
export var link = "_kf-f";
export var overflowEllipsis = "_kf-e";